/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `provider` - Provider
 * * `healthcare_entity_rep` - Healthcare Entity Representative
 * * `staff` - Staff
 */
export enum UserTypeEnum {
    PROVIDER = 'provider',
    HEALTHCARE_ENTITY_REP = 'healthcare_entity_rep',
    STAFF = 'staff',
}
